import React, { useState, useEffect, FC } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Badge,
  Card,
  Spinner,
  Input,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import {
  Button,
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../../components/Component";
import { Row, Col, Collapse } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import sitebreakdownMasterApis from "../../../api/master/sitebreakdownMaster";
import { FormProvider, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Flex, Modal, Spin, Dropdown, Menu, Table, Drawer, Alert } from "antd";
import AddSiteStructureForm from "./steps/AddSiteStructureForm";
import dayjs from "dayjs";
import { normalizeStatus } from "../../../utils/Utils";

interface SelectOptions {
  label: string;
  value: string;
}
interface SelectedItems {
  units: number[];
  subUnits: number[];
}
interface SubUnit {
  key: string;
  id?: number;
  subUnitName: string;
  unit: number;
  floorNo?: string;
  floorType?: string;
  plannedStartDate?: string;
  plannedEndDate?: string;
  description?: string;
}
interface SiteStructure {
  key: string;
  id?: number;
  unitName: string;
  unitQty: number;
  noOfFloors?: number;
  unitPerFloor?: number;
  noOfUnitsPerFloor?: number;
  plannedStartDate?: string;
  plannedEndDate?: string;
  isChildExist?: boolean;
  description?: string;
  unitUomId?: number;
  subUnits?: SubUnit[];
  errorFlag?: boolean;
  errorMessage?: string | string[];
  status?: string;
}

const SitesStructureViewDetails: FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });

  const [sm, updateSm] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  let { id } = useParams();
  const [data, setData] = useState<any>();
  const [projectTypeName, setProjectTypeName] = useState("");
  const [expandedUnits, setExpandedUnits] = useState<number[]>([]);
  const [selectedItems, setSelectedItems] = useState<SelectedItems>({
    units: [],
    subUnits: [],
  });
  const [selectAll, setSelectAll] = useState(false);
  const [showBulkActions, setShowBulkActions] = useState(false);
  const [backupRecord, setBackupRecord] = useState<SiteStructure | null>(null);

  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [editingRecord, setEditingRecord] = useState<SiteStructure | null>(
    null
  );
  // console.log(editingRecord, "editn");

  const [uploadAlert, setUploadAlert] = useState<{
    type: string;
    message: string;
  } | null>(null);
  const [formError, setFormError] = useState<{
    type: string;
    message: string;
  } | null>(null);
  const clearFormError = () => {
    setFormError(null);
  };

  const methods = useForm<any>({
    mode: "onChange",
    defaultValues: {
      id: "",
      siteName: "",
      projectName: "",
      projectType: "",
      status: "",
    },
  });

  const { reset, getValues } = methods;

  const projectType = getValues("projectType");

  const getUnitTypeName = () => {
    switch (projectType) {
      case "1":
        return "Villa";
      case "2":
        return "Tower";
      case "3":
        return "Block";
      case "4":
        return "Tower";
      case "5":
        return "Phase";
      default:
        return "Unit";
    }
  };

  const openAddDrawer = (record?: any) => {
    if (record) {
      const transformedRecord: SiteStructure = {
        key: record.id ? `unit_${record.id}` : `temp_${Date.now()}`,
        id: record.id ? Number(record.id) : undefined,
        unitName: record.unitName,
        unitQty: record.unitQty,
        noOfFloors: record.noOfFloors,
        unitPerFloor: record.noOfUnitsPerFloor,
        noOfUnitsPerFloor: record.noOfUnitsPerFloor,
        plannedStartDate: record.plannedStartDate,
        plannedEndDate: record.plannedEndDate,
        isChildExist: record.isChildExist,
        description: record.description || "",
        unitUomId: record.unitUomId || 1,
        status: normalizeStatus(record.status),
        subUnits:
          record.subUnits?.map((s: any) => ({
            key: `sub_${s.id || Date.now()}`,
            id: s.id ? Number(s.id) : undefined,
            subUnitName: s.subUnitName,
            unit: s.unit,
            floorNo: s.floorNo,
            floorType: s.floorType || "residential",
            plannedStartDate: s.plannedStartDate,
            plannedEndDate: s.plannedEndDate,
            description: s.description || "",
          })) || [],
      };
      // console.log("Transformed Record:", transformedRecord);

      setEditingRecord(transformedRecord);
      setBackupRecord(transformedRecord);
    } else {
      setEditingRecord(null);
      setBackupRecord(null);
    }
    setShowAddDrawer(true);
  };
  const handleManualSave = async (newStructure: any) => {
    try {
      setIsLoading(true);
      setFormError(null);

      const siteId = parseInt(id || "0", 10);
      const projectTypeId = data?.projectTypeId || parseInt(projectType);
      const projectName = data?.projectName || "";

      const originalUnit = editingRecord?.id
        ? data?.units?.find(
            (u: any) => Number(u.id) === Number(editingRecord.id)
          )
        : null;

      // console.log("DEBUG - Editing Record ID:", editingRecord?.id);
      // console.log("DEBUG - Original Unit:", originalUnit);
      // console.log("DEBUG - New Structure:", newStructure);

      const transformedData = transformFormDataToApiFormat(
        newStructure,
        projectType
      );

      // console.log("DEBUG - Transformed Data:", transformedData);

      const changedData = getChangedFields(transformedData, originalUnit);

      // console.log("DEBUG - Changed Data:", changedData);

      const payload = {
        // siteId,
        // projectName,
        // projectTypeId,
        units: [changedData],
      };

      console.log("📤 Final Payload:", JSON.stringify(payload, null, 2));

      const { status: apiStatus, message } =
        await sitebreakdownMasterApis.updateSiteBreakDownById(siteId, payload);

      if (apiStatus) {
        setShowAddDrawer(false);
        setEditingRecord(null);
        setFormError(null);
        // setUploadAlert({
        //   type: "success",
        //   message: `${getUnitTypeName()} "${newStructure.unitName}" ${
        //     editingRecord ? "updated" : "added"
        //   } successfully.`,
        // });
        await fetchSiteStructureDetails(id);
        // setTimeout(() => setUploadAlert(null), 5000);
      } else {
        throw new Error(message);
      }
    } catch (err: any) {
      const errorMessage =
        err?.response?.data?.message ||
        err.message ||
        "Failed to save structure.";
      const errorData = err?.response?.data?.data;

      let detailedError = errorMessage;
      if (errorData && Array.isArray(errorData)) {
        detailedError = `${errorMessage}\n\n${errorData.join("\n")}`;
      }

      // setUploadAlert({
      //   type: "error",
      //   message: detailedError,
      // });

      setFormError({
        type: "error",
        message: detailedError,
      });

      if (backupRecord) {
        setEditingRecord({ ...backupRecord });
      }

      // setTimeout(() => setUploadAlert(null), 8000);
    } finally {
      setIsLoading(false);
    }
  };

  const transformFormDataToApiFormat = (formData: any, projectType: string) => {
    const apiData: any = {};

    if (formData.id) {
      apiData.id = Number(formData.id);
    }

    apiData.unitName = formData.unitName;
    apiData.unitQty = parseInt(formData.unitQty) || 0;
    apiData.unitUomId = 1;
    apiData.description = formData.description || formData.unitName || "";
    apiData.isChildExist = formData.captureSubUnits === "Yes";

    if (formData.noOfFloors) {
      apiData.noOfFloors = parseInt(formData.noOfFloors) || 0;
    }
    if (formData.unitPerFloor) {
      apiData.unitPerFloor = parseInt(formData.unitPerFloor) || 0;
      apiData.noOfUnitsPerFloor = parseInt(formData.unitPerFloor) || 0;
    }
    if (formData.plannedStartDate) {
      apiData.plannedStartDate = formData.plannedStartDate;
    }
    if (formData.plannedEndDate) {
      apiData.plannedEndDate = formData.plannedEndDate;
    }

    if (
      apiData.isChildExist &&
      formData.subUnits &&
      formData.subUnits.length > 0
    ) {
      apiData.subUnits = formData.subUnits.map((subUnit: any) => {
        const transformedSubUnit: any = {};

        if (
          subUnit.id &&
          typeof subUnit.id === "string" &&
          subUnit.id.startsWith("sub_")
        ) {
          transformedSubUnit.id = parseInt(subUnit.id.replace("sub_", ""));
        } else if (subUnit.id) {
          transformedSubUnit.id = Number(subUnit.id);
        }

        transformedSubUnit.subUnitName =
          subUnit.subUnitName || subUnit.name || "";
        transformedSubUnit.unit = parseInt(subUnit.unit || subUnit.size) || 0;
        transformedSubUnit.floorNo =
          subUnit.floorNo || subUnit.floor?.toString() || "1";
        transformedSubUnit.description =
          subUnit.description ||
          `${subUnit.subUnitName || subUnit.name} in ${formData.unitName}`;

        switch (projectType) {
          case "1": // Villa
            transformedSubUnit.floorType = "residential";
            break;
          case "2": // Highrise
            transformedSubUnit.floorType = "residential";
            break;
          case "3": // Standalone
            transformedSubUnit.floorType = "residential";
            break;
          case "4": // Commercial
            transformedSubUnit.floorType = "commercial";
            break;
          case "5": // Infrastructure
            transformedSubUnit.floorType = "residential";
            break;
          default:
            transformedSubUnit.floorType = "residential";
        }

        if (subUnit.plannedStartDate || subUnit.startDate) {
          transformedSubUnit.plannedStartDate =
            subUnit.plannedStartDate || subUnit.startDate;
        }
        if (subUnit.plannedEndDate || subUnit.endDate) {
          transformedSubUnit.plannedEndDate =
            subUnit.plannedEndDate || subUnit.endDate;
        }

        return transformedSubUnit;
      });
    }

    return apiData;
  };

  const getChangedFields = (newData: any, originalData: any) => {
    if (!originalData || !originalData.id) {
      const newDataWithoutIds = {
        ...newData,
        isChildExist: newData.isChildExist,
      };

      delete newDataWithoutIds.id;

      if (newDataWithoutIds.subUnits && newDataWithoutIds.subUnits.length > 0) {
        newDataWithoutIds.subUnits = newDataWithoutIds.subUnits.map(
          (subUnit: any) => {
            const subUnitWithoutId = { ...subUnit };
            delete subUnitWithoutId.id;
            return subUnitWithoutId;
          }
        );
      }

      return newDataWithoutIds;
    }

    const changedData: any = {
      id: originalData.id,
    };

    if (newData.isChildExist !== undefined) {
      changedData.isChildExist = newData.isChildExist;
      console.log("🔄 UPDATING isChildExist:", newData.isChildExist);
    }

    const originalSubUnitsMap = new Map();

    if (originalData.subUnits) {
      originalData.subUnits.forEach((sub: any) => {
        if (sub.id) {
          originalSubUnitsMap.set(sub.id, sub);
        }
      });
    }

    const unitFields = [
      "unitName",
      "unitQty",
      "noOfFloors",
      "unitPerFloor",
      "noOfUnitsPerFloor",
      "plannedStartDate",
      "plannedEndDate",
      "description",
      // "isChildExist",
    ];

    unitFields.forEach((field) => {
      const newValue = normalizeValue(newData[field]);
      const originalValue = normalizeValue(originalData[field]);

      if (field === "isChildExist") {
        if (newValue !== originalValue || newData[field] !== undefined) {
          changedData[field] = newData[field];
        }
      } else if (newValue !== originalValue) {
        changedData[field] = newData[field];
      } else if (newData[field] !== undefined) {
        changedData[field] = newData[field];
      }
    });

    changedData.unitUomId = newData.unitUomId || 1;

    if ((newData.isChildExist && newData.subUnits) || originalData.subUnits) {
      const changedSubUnits: any[] = [];

      if (newData.subUnits) {
        newData.subUnits.forEach((newSub: any) => {
          if (newSub.id && originalSubUnitsMap.has(newSub.id)) {
            const originalSub = originalSubUnitsMap.get(newSub.id);
            const changedSub = getChangedSubUnitFields(newSub, originalSub);

            changedSubUnits.push({
              id: newSub.id,
              ...newSub,
            });
          } else {
            const newSubWithoutId = { ...newSub };
            delete newSubWithoutId.id;
            changedSubUnits.push(newSubWithoutId);
          }
        });
      }

      if (changedSubUnits.length > 0) {
        changedData.subUnits = changedSubUnits;
      } else if (
        !newData.isChildExist &&
        originalData.subUnits &&
        originalData.subUnits.length > 0
      ) {
        changedData.subUnits = [];
      }
    }
    return changedData;
  };

  const getChangedSubUnitFields = (newSub: any, originalSub: any) => {
    const changedSub: any = {};
    const subUnitFields = [
      "subUnitName",
      "unit",
      "floorNo",
      "floorType",
      "plannedStartDate",
      "plannedEndDate",
      "description",
    ];

    subUnitFields.forEach((field) => {
      const newValue = normalizeValue(newSub[field]);
      const originalValue = normalizeValue(originalSub[field]);

      if (newValue !== originalValue) {
        changedSub[field] = newSub[field];
      }
    });

    return changedSub;
  };

  const normalizeValue = (val: any) => {
    if (val == null || val === "" || val === undefined) return null;
    if (typeof val === "number") return val;
    if (typeof val === "boolean") return val;
    if (dayjs(val, "YYYY-MM-DD", true).isValid())
      return dayjs(val).format("YYYY-MM-DD");
    return String(val).trim();
  };

  const updateUIVisibility = (items: SelectedItems) => {
    const hasSelections = items.units.length > 0 || items.subUnits.length > 0;
    setShowBulkActions(hasSelections);
  };

  const toggleUnit = (unitId: number) => {
    setExpandedUnits((prev) =>
      prev.includes(unitId)
        ? prev.filter((id) => id !== unitId)
        : [...prev, unitId]
    );
  };

  const handleBulkAction = async (
    action: string,
    ids: number[],
    type: "units" | "subUnits"
  ) => {
    try {
      let response;
      const payload = { ids };

      if (!ids || ids.length === 0) {
        Swal.fire("Error!", "Please select at least one item.", "error");
        return;
      }

      // For delete action, show confirmation dialog first
      if (action === "delete") {
        const entityText = type === "units" ? "unit(s)" : "sub-unit(s)";
        const count = ids.length;
        const result = await Swal.fire({
          title: "Are you sure?",
          text: `Do you want to delete ${count} ${entityText}? You won't be able to revert this!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-secondary",
          },
        });

        // Only proceed if user confirmed
        if (!result.isConfirmed) {
          return;
        }
      }

      switch (action) {
        case "activate":
          response =
            type === "units"
              ? await sitebreakdownMasterApis.activateUnitsByIds(payload)
              : await sitebreakdownMasterApis.activateSubUnitsByIds(payload);
          break;
        case "inactivate":
          response =
            type === "units"
              ? await sitebreakdownMasterApis.inactivateUnitsByIds(payload)
              : await sitebreakdownMasterApis.inactivateSubUnitsByIds(payload);
          break;
        case "hold":
          response =
            type === "units"
              ? await sitebreakdownMasterApis.holdUnitsByIds(payload)
              : null;
          break;
        case "delete":
          response =
            type === "units"
              ? await sitebreakdownMasterApis.deleteUnitsByIds(payload)
              : await sitebreakdownMasterApis.deleteSubUnitsByIds(payload);
          break;
        default:
          Swal.fire("Error!", "Invalid action type.", "error");
          return;
      }

      if (response?.status) {
        const entityText = type === "units" ? "Units" : "Sub-units";
        let actionText = "";
        switch (action) {
          case "activate":
            actionText = `${entityText} have been activated.`;
            break;
          case "inactivate":
            actionText = `${entityText} have been inactivated.`;
            break;
          case "hold":
            actionText = `${entityText} have been put on hold.`;
            break;
          case "delete":
            actionText = `${entityText} have been deleted.`;
            break;
          default:
            actionText = `${entityText} have been updated.`;
        }

        Swal.fire({ icon: "success", title: "Done", text: actionText });
        fetchSiteStructureDetails(id);
        const clearedItems = { units: [], subUnits: [] };
        setSelectedItems(clearedItems);
        setSelectAll(false);
        updateUIVisibility(clearedItems);
      } else {
        const errMsg =
          response?.message || response?.data?.message || "Operation failed.";
        Swal.fire("Error!", errMsg, "error");
      }
    } catch (error: any) {
      console.error("Bulk Action Error:", error);
      const errMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong.";
      Swal.fire({ icon: "error", title: "Action Failed!", text: errMsg });
    }
  };

  const renderBulkActionMenu = (type: "units" | "subUnits") => {
    const items = [
      {
        key: "activate",
        label: "Activate Selected",
        onClick: () => handleBulkAction("activate", selectedItems[type], type),
      },
      {
        key: "inactivate",
        label: "Inactivate Selected",
        onClick: () =>
          handleBulkAction("inactivate", selectedItems[type], type),
      },
    ];

    if (type === "units") {
      items.push({
        key: "hold",
        label: "Put on Hold",
        onClick: () => handleBulkAction("hold", selectedItems.units, "units"),
      });
    }

    items.push({
      key: "delete",
      label: "Delete Selected",
      onClick: () => handleBulkAction("delete", selectedItems[type], type),
    });
    return <Menu items={items} />;
  };

  const renderIndividualActionMenu = (
    record: any,
    type: "units" | "subUnits"
  ) => {
    const currentStatus = normalizeStatus(record.status);
    const menuItems: any[] = [];

    if (type === "units" && currentStatus !== "Inactive") {
      menuItems.push({
        key: "edit",
        label: "Edit",
        onClick: () => openAddDrawer(record),
      });
    }

    if (currentStatus !== "Active") {
      menuItems.push({
        key: "activate",
        label: "Activate",
        onClick: () => handleBulkAction("activate", [record.id], type),
      });
    }

    if (currentStatus !== "Inactive") {
      menuItems.push({
        key: "inactivate",
        label: "Inactivate",
        onClick: () => handleBulkAction("inactivate", [record.id], type),
      });
    }

    if (type === "units" && currentStatus !== "OnHold") {
      menuItems.push({
        key: "hold",
        label: "Put on Hold",
        onClick: () => handleBulkAction("hold", [record.id], "units"),
      });
    }

    menuItems.push({
      key: "delete",
      label: "Delete",
      onClick: async () => {
        const entityText = type === "units" ? getUnitTypeName() : "Sub-unit";
        const result = await Swal.fire({
          title: "Are you sure?",
          text: `You are about to delete ${entityText} "${
            record.unitName || record.subUnitName
          }". This action cannot be undone!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
          allowOutsideClick: false,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-secondary",
          },
        });

        if (result.isConfirmed) {
          await handleBulkAction("delete", [record.id], type);
        }
      },
    });

    return <Menu items={menuItems} />;
  };

  useEffect(() => {
    if (accessibility) {
      try {
        const { add, view, edit, approve, reject, cancel } =
          accessibility["Master"];
        setAllowedActions({ add, view, edit, approve, reject, cancel });
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);

  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      updateSm(false);
    }
  };

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);

    if (id) {
      fetchSiteStructureDetails(id);
    }

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, [id]);

  const fetchSiteStructureDetails = async (id: any) => {
    try {
      setIsLoading(true);
      const { data: apiData, status: responseStatus } =
        await sitebreakdownMasterApis.fetchSiteBreakDownById(id);

      if (responseStatus) {
        setData(apiData);
        reset({
          id: apiData.id?.toString() || "",
          siteName: apiData.siteName || "",
          projectName: apiData.projectName || "",
          projectType: apiData.projectTypeId?.toString() || "",
          status: normalizeStatus(apiData.status) || "active",
        });

        if (apiData.projectTypeName) {
          setProjectTypeName(apiData.projectTypeName);
        }
      }
      setIsLoading(false);
    } catch (err: any) {
      console.log(err);
      Swal.fire(
        "Failed!",
        err.response?.data?.message || "Failed to load details",
        "error"
      );
      setIsLoading(false);
    }
  };

  const renderStructureTable = () => {
    if (!data || !data.units || data.units.length === 0) {
      return <div className="text-center p-4">No structure data available</div>;
    }

    const hasSelectedUnits = selectedItems.units.length > 0;
    const hasSelectedSubUnits = selectedItems.subUnits.length > 0;

    const getIconName = (actionKey: string): string => {
      switch (actionKey) {
        case "edit":
          return "edit";
        case "activate":
          return "check-circle";
        case "inactivate":
          return "cross-circle";
        case "hold":
          return "pause";
        case "delete":
          return "trash";
        default:
          return "more-h";
      }
    };

    const getSubUnitsByType = (unit: any) => {
      if (!unit.subUnits) return { flats: [], shops: [], milestones: [] };

      const pt = projectType;

      if (pt === "1") return { flats: [], shops: [], milestones: [] };

      if (pt === "2" || pt === "3") {
        const flats = unit.subUnits;
        return { flats, shops: [], milestones: [] };
      }

      if (pt === "4") {
        const shops = unit.subUnits.filter(
          (sub: any) => sub.floorType === "commercial"
        );
        return { flats: [], shops, milestones: [] };
      }

      if (pt === "5") {
        const milestones = unit.subUnits;
        return { flats: [], shops: [], milestones };
      }

      return { flats: [], shops: [], milestones: [] };
    };

    const renderSubUnitsTable = (
      unit: any,
      subUnits: any[],
      type: "flats" | "shops" | "milestones"
    ) => {
      if (!subUnits || subUnits.length === 0) return null;

      const subUnitColumns = [
        ...(projectType !== "5"
          ? [
              {
                title: (
                  <span style={{ paddingLeft: "8px" }}>
                    {type === "milestones" ? "" : "Floor"}
                  </span>
                ),
                dataIndex: "floorNo",
                key: "floorNo",
                width: 100,
                render: (text: any) =>
                  type !== "milestones" ? (
                    <span style={{ paddingLeft: "16px" }}>{text || "-"}</span>
                  ) : (
                    "-"
                  ),
              },
            ]
          : []),
        {
          title: (
            <div style={{ paddingLeft: 30 }}>
              {type === "milestones"
                ? "Milestone Name"
                : type === "shops"
                ? "Shop Number"
                : "Flat Number"}
            </div>
          ),
          dataIndex: "subUnitName",
          key: "subUnitName",
          width: 150,
          render: (text: any) => <div style={{ paddingLeft: 30 }}>{text}</div>,
        },
         {
          title: type === "milestones" ? "Cubic Meters" : "Square Feet",
          dataIndex: "unit",
          key: "unit_unitUomName",
          width: 120,
          render: (_: any, record: any) => {
            const unitUomName = unit?.unitUomName;
            return (
              <span>
                {record?.unit ? record.unit : "N/A"}{" "}
                {unitUomName ? unitUomName : ""}
              </span>
            );
          },
        },
        {
          title: "Planned Start Date",
          dataIndex: "plannedStartDate",
          key: "plannedStartDate",
          width: 120,
          render: (text: any) =>
            text ? dayjs(text).format("DD-MMM-YYYY") : "N/A",
        },
        {
          title: "Planned End Date",
          dataIndex: "plannedEndDate",
          key: "plannedEndDate",
          width: 120,
          render: (text: any) =>
            text ? dayjs(text).format("DD-MMM-YYYY") : "N/A",
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          width: 120,
          render: (text: string) => {
            const status = normalizeStatus(text);

            let color = "";
            switch (status) {
              case "Active":
                color = "#28a745";
                break;
              case "Inactive":
                color = "#dc3545";
                break;
              case "OnHold":
                color = "#ffc107";
                break;
              default:
                color = "#6c757d";
            }

            return <span style={{ color, fontWeight: 600 }}>{status}</span>;
          },
        },
        // {
        //   title: "Actions",
        //   key: "actions",
        //   width: 100,
        //   render: (text: any, subUnit: any) => (
        //     <div className="text-center">
        //       <Dropdown
        //         overlay={renderIndividualActionMenu(subUnit, "subUnits")}
        //         trigger={["click"]}
        //         placement="bottomRight"
        //         arrow={{ pointAtCenter: true }}
        //         overlayClassName="custom-action-dropdown"
        //       >
        //         <a
        //           onClick={(e) => e.preventDefault()}
        //           style={{ cursor: "pointer" }}
        //         >
        //           <Icon name="more-h" className="fs-6" />
        //         </a>
        //       </Dropdown>
        //     </div>
        //   ),
        // },
      ];

      return (
        <div className="mt-3">
          <div className="d-flex align-items-center mb-2">
            <h6
              className="mb-0 fw-bold text-dark fs-6"
              style={{ minWidth: "120px", marginLeft: 12 }}
            >
              {type === "flats"
                ? "FLATS"
                : type === "shops"
                ? "SHOPS"
                : "MILESTONES"}
            </h6>
            <div className="flex-grow-1 border-bottom"></div>
          </div>
          {/* Use Ant Design Table for sub-units to match TransactionFlowDefaultTemplate */}
          <Table
            className="customTable"
            columns={subUnitColumns}
            dataSource={subUnits.map((subUnit, index) => ({
              key: `subunit-${subUnit.id}-${index}`,
              ...subUnit,
            }))}
            pagination={false}
            size="middle"
            scroll={{ x: 800 }}
            bordered
            style={{ padding: 15 }}
          />
        </div>
      );
    };

    const mainColumns = [
      {
        title: (
          <span style={{ paddingLeft: 8 }}>
            {projectType === "1"
              ? "Villa Number"
              : projectType === "2" || projectType === "4"
              ? "Tower Name"
              : projectType === "3"
              ? "Block Name"
              : "Phase Name"}
          </span>
        ),
        dataIndex: "unitName",
        key: "unitName",
        width: 150,
        render: (text: any, record: any) => (
          <div className="d-flex align-items-center">
            {record.subUnits && record.subUnits.length > 0 && (
              <Button
                size="sm"
                onClick={() => toggleUnit(record.id)}
                className="p-0 me-2 btn-icon"
                // color="light"
                style={{ width: "24px", height: "24px" }}
              >
                <Icon
                  name={
                    expandedUnits.includes(record.id)
                      ? "chevron-down"
                      : "chevron-right"
                  }
                  className="fs-6"
                ></Icon>
              </Button>
            )}
            <span className="fw-medium" style={{ paddingLeft: 16 }}>
              {text}
            </span>
          </div>
        ),
      },
      {
        title: <span>Site ID</span>,
        key: "siteStructureSequenceId",
        width: 130,
        render: () => <div>{data?.siteStructureSequenceId || "-"}</div>,
      },
      ...(projectType !== "1" && projectType !== "5"
        ? [
            {
              title: "Floors",
              dataIndex: "noOfFloors",
              key: "noOfFloors",
              width: 100,
              render: (text: any) => text || "-",
            },
          ]
        : []),
      ...(projectType !== "1" && projectType !== "5"
        ? [
            {
              title: (() => {
                switch (projectType) {
                  // case "1": // Villa
                  //   return "Units/Villa";
                  case "2": // Highrise
                  case "3": // Standalone
                    return "Flats per Floor";
                  case "4": // Commercial
                    return "Shops per  Floor";
                  // case "5": // Infrastructure
                  //   return "Milestones per Phase";
                  // default:
                  //   return "Units per Floor";
                }
              })(),
              dataIndex: "noOfUnitsPerFloor",
              key: "noOfUnitsPerFloor",
              width: 120,
              render: (text: any) => text || "-",
            },
          ]
        : []),
      {
        title: projectType === "5" ? "Cubic Meters" : "SFT",
        dataIndex: "unitQty",
        key: "unitQty_unitUomName",
        width: 150,
        render: (_: any, record: any) => {
          return (
            <span>
              {record?.unitQty ? record.unitQty : "N/A"}{" "}
              {record?.unitUomName ? record.unitUomName : ""}
            </span>
          );
        },
      },
      {
        title: "Planned Start Date",
        dataIndex: "plannedStartDate",
        key: "plannedStartDate",
        width: 120,
        render: (text: any) =>
          text ? dayjs(text).format("DD-MMM-YYYY") : "N/A",
      },
      {
        title: "Planned End Date",
        dataIndex: "plannedEndDate",
        key: "plannedEndDate",
        width: 120,
        render: (text: any) =>
          text ? dayjs(text).format("DD-MMM-YYYY") : "N/A",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 120,
        render: (text: string) => {
          const status = normalizeStatus(text);

          let color = "";
          switch (status) {
            case "Active":
              color = "#28a745";
              break;
            case "Inactive":
              color = "#dc3545";
              break;
            case "OnHold":
              color = "#ffc107";
              break;
            default:
              color = "#6c757d";
          }

          return <span style={{ color, fontWeight: 600 }}>{status}</span>;
        },
      },
      // {
      //   title: "Actions",
      //   key: "actions",
      //   width: 100,
      //   render: (text: any, record: any) => (
      //     <div className="text-center">
      //       <Dropdown
      //         overlay={renderIndividualActionMenu(record, "units")}
      //         trigger={["click"]}
      //         placement="bottomRight"
      //         arrow={{ pointAtCenter: true }}
      //         overlayClassName="custom-action-dropdown"
      //       >
      //         <a
      //           onClick={(e) => e.preventDefault()}
      //           style={{ cursor: "pointer" }}
      //         >
      //           <Icon name="more-h" className="fs-6" />
      //         </a>
      //       </Dropdown>
      //     </div>
      //   ),
      // },
      {
        title: "Actions",
        key: "actions",
        width: 100,
        render: (text: any, record: any) => {
          const menu = renderIndividualActionMenu(record, "units");

          return (
            <div className="text-center">
              <UncontrolledDropdown direction="start">
                <DropdownToggle
                  tag="button"
                  className="btn btn-sm btn-icon btn-light"
                  style={{
                    border: "none",
                    background: "none",
                    position: "relative",
                    zIndex: 1,
                    color: "#526484",
                  }}
                >
                  <Icon name="more-h" style={{ color: "inherit" }}></Icon>
                </DropdownToggle>
                <DropdownMenu
                  end
                  style={{
                    position: "fixed",
                    minWidth: "160px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    border: "1px solid #e5e5e5",
                    zIndex: 9999,
                    inset: "auto auto auto auto !important",
                  }}
                  container="body"
                >
                  <ul className="link-list-opt no-bdr" style={{ margin: 0 }}>
                    {menu?.props?.items?.map((item: any) => (
                      <li key={item.key}>
                        <DropdownItem
                          tag="a"
                          href={`#${item.key}`}
                          onClick={(ev) => {
                            ev.preventDefault();
                            item.onClick();
                          }}
                          style={{
                            padding: "8px 16px",
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                          }}
                        >
                          <Icon
                            name={getIconName(item.key)}
                            className="me-2"
                          ></Icon>
                          <span>{item.label}</span>
                        </DropdownItem>
                      </li>
                    ))}
                  </ul>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          );
        },
      },
    ];

    const CustomRow = (props: any) => {
      const record = props["data-row-key"];
      const unit = data.units.find((u: any) => u.id === record);

      if (!unit) return <tr {...props} />;

      const isExpanded = expandedUnits.includes(unit.id);
      const hasSubUnits = unit.subUnits && unit.subUnits.length > 0;
      const subUnitsByType = getSubUnitsByType(unit);

      return (
        <>
          <tr {...props} className={isExpanded ? "table-active" : ""} />
          {hasSubUnits && isExpanded && (
            <tr>
              <td colSpan={mainColumns.length} className="p-0 border-0">
                <div
                  className="bg-light border-top"
                  style={{ padding: "8px 0 0 0", marginTop: 0 }}
                >
                  {subUnitsByType.flats.length > 0 &&
                    renderSubUnitsTable(unit, subUnitsByType.flats, "flats")}
                  {subUnitsByType.shops.length > 0 &&
                    renderSubUnitsTable(unit, subUnitsByType.shops, "shops")}
                  {subUnitsByType.milestones.length > 0 &&
                    renderSubUnitsTable(
                      unit,
                      subUnitsByType.milestones,
                      "milestones"
                    )}
                </div>
              </td>
            </tr>
          )}
        </>
      );
    };

    return (
      <div>
        {/* Bulk Actions Toolbar */}
        {/* {showBulkActions && (
          <Card className="mb-3 p-3 bg-light border">
            <Row className="align-items-center">
              <Col md="6">
                <strong className="text-dark">
                  {hasSelectedUnits &&
                    `${selectedItems.units.length} unit(s) selected`}
                  {hasSelectedUnits && hasSelectedSubUnits && ", "}
                  {hasSelectedSubUnits &&
                    `${selectedItems.subUnits.length} sub-unit(s) selected`}
                </strong>
              </Col>
              <Col md="6" className="text-end">
                {hasSelectedUnits && (
                  <Dropdown overlay={renderBulkActionMenu("units")}>
                    <Button color="primary" size="sm" className="me-2">
                      Unit Actions{" "}
                      <Icon name="chevron-down" className="ms-1"></Icon>
                    </Button>
                  </Dropdown>
                )}
              </Col>
            </Row>
          </Card>
        )} */}

        {/* Main Table - Using Ant Design Table to match TransactionFlowDefaultTemplate */}
        <Table
          className="customTable"
          columns={mainColumns}
          dataSource={data.units.map((unit: any) => ({
            key: unit.id,
            ...unit,
          }))}
          pagination={false}
          size="middle"
          scroll={{ x: 1000 }}
          bordered
          components={{
            body: {
              row: CustomRow,
            },
          }}
        />
      </div>
    );
  };

  return (
    <React.Fragment>
      <Head title="Site Structure Details"></Head>
      <Content>
        {data && (
          <>
            <BlockHead size="sm">
              <BlockBetween className="g-3">
                <BlockHeadContent>
                  <BlockTitle page>
                    Site Structure Details -{" "}
                    <strong className="text-primary">
                      {data["projectName"]}
                    </strong>
                  </BlockTitle>
                  <BlockDes className="text-soft">
                    <ul className="list-inline">
                      <li>
                        Site Name:{" "}
                        <span className="text-base">{data.siteName}</span>
                      </li>
                      <li>
                        Project Type:{" "}
                        <span className="text-base">{projectTypeName}</span>
                      </li>
                      <li>
                        Total Units:{" "}
                        <span className="text-base">
                          {data.units?.length || 0}
                        </span>
                      </li>
                    </ul>
                  </BlockDes>
                </BlockHeadContent>
                <BlockHeadContent>
                  <div
                    className="d-flex align-items-center justify-content-end flex-wrap gap-2"
                    style={{ gap: "10px" }}
                  >
                    <Button
                      color="primary"
                      size="md"
                      className="fw-semibold"
                      onClick={() => openAddDrawer()}
                    >
                      <Icon name="plus" className="me-1" />
                      {/* Add New {getUnitTypeName()} */}
                      Add
                    </Button>

                    <Button
                      color="light"
                      size="md"
                      className="fw-semibold"
                      onClick={() => window.history.back()}
                    >
                      <Icon name="arrow-left" className="me-1" />
                      Back
                    </Button>
                  </div>
                </BlockHeadContent>
              </BlockBetween>
            </BlockHead>

            {isLoading ? (
              <Flex align="center" gap="middle" className="pageLoader">
                <Spin size="large" className="m-auto" />
              </Flex>
            ) : (
              <Block>
                <Row className="gy-5">
                  <Col lg="12">
                    <Card className="card-bordered">
                      {uploadAlert && (
                        <div className="p-3">
                          <Alert
                            message={uploadAlert.message}
                            type={
                              uploadAlert.type === "success"
                                ? "success"
                                : "error"
                            }
                            showIcon
                            closable
                            onClose={() => setUploadAlert(null)}
                          />
                        </div>
                      )}
                      {renderStructureTable()}
                    </Card>
                  </Col>
                </Row>
              </Block>
            )}

            {/* ⚠️ Drawer for Add/Edit (NO MODAL) */}
            <Drawer
              title={
                editingRecord
                  ? `Edit ${getUnitTypeName()}`
                  : `Add ${getUnitTypeName()}`
              }
              placement="right"
              onClose={() => {
                setShowAddDrawer(false);
                setEditingRecord(null);
                setFormError(null);
              }}
              open={showAddDrawer}
              width={1200}
              destroyOnClose
            >
              <AddSiteStructureForm
                projectType={projectType}
                editData={editingRecord}
                onSave={handleManualSave}
                onCancel={() => {
                  setShowAddDrawer(false);
                  setEditingRecord(null);
                  setFormError(null);
                }}
                error={formError}
                onClearError={clearFormError}
              />
            </Drawer>
          </>
        )}
      </Content>
    </React.Fragment>
  );
};

export default SitesStructureViewDetails;
